import { Routes } from '@angular/router';
import { homeRoutes } from './features/home/home.routes';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { HomeLayoutComponent } from './layouts/home-layout/home-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AUTH_ROUTES } from './features/auth/auth.routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: AUTH_ROUTES,
  },
  {
    path: 'home',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    children: homeRoutes,
  },
  {
    path: 'survey',
    loadComponent: () =>
      import('./features/survey-response/survey-response.component').then(
        (m) => m.SurveyResponseComponent
      ),
  },
  { path: '**', component: NotFoundComponent },
];
